import { render, staticRenderFns } from "./LoginBoxed.vue?vue&type=template&id=ad2710a2"
import script from "./LoginBoxed.vue?vue&type=script&lang=js"
export * from "./LoginBoxed.vue?vue&type=script&lang=js"
import style0 from "./LoginBoxed.vue?vue&type=style&index=0&id=ad2710a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports